// ABOUTME: Progression modal for MFA setup wizard.
// ABOUTME: Three steps: scan QR, verify code, save recovery codes.
import { useTranslation } from "react-i18next";
import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import ScanQr from "./views/ScanQr";
import VerifyCode from "./views/VerifyCode";
import RecoveryCodes from "./views/RecoveryCodes";

const MpSetupMfa = (props) => {
    const { t } = useTranslation();

    const onSave = () => {
        props.handleClose();
    };

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper
                onSave={onSave}
                isModal
                title={t("setup_mfa")}
                hideButtons
            >
                <ScanQr setupData={props.setupData} />
                <VerifyCode />
                <RecoveryCodes />
            </ProgressionWrapper>
        </ProgressionModal>
    );
};

export default MpSetupMfa;
